export default {
	scrollToTop: {
		element: '[data-spot-scroll-top]',
	},
	select: {
		selected: '[data-select-selected]',
		option: '[data-select-option]',
		selectedText: '[data-select-selected-text]',
	},
	promoCarousel: {
		swiper: '[data-promo-carousel]',
		navPrev: '.promo-carousel-nav-prev',
		navNext: '.promo-carousel-nav-next',
	},
	alsoChooseCarousel: {
		swiper: '[data-also-choose-carousel]',
		navPrev: '[data-also-choose-carousel-prev-btn]',
		navNext: '[data-also-choose-carousel-next-btn]',
		pagination: '[data-pagination="also-choose"]',
	},
	// TODO replace with new accordion
	accordion: {
		element: '[data-ac]',
		toggle: '[data-ac-toggle]',
		content: '[data-ac-content]',
		icon: '[data-ac-icon]',
	},
	accordionNew: {
		element: '[data-accordion]',
		toggle: '[data-accordion-btn]',
	},
	articles: {
		carousel: {
			mobile: {
				element: '.articles-mobile-carousel',
				pagination: '.articles-mobile-carousel-pagination',
			},
		},
	},
	oilChangeCarousel: {
		pagination: {
			elementOfFirst: '[data-pagination="1"]',
			elementOfSecond: '[data-pagination="2"]',
		},
	},
	footer: {
		citySelect: '[data-select="footer-city"]',
	},
	header: {
		search: '[data-search="header"]',
	},
	catalog: {
		filter: '[data-catalog-filter]',
		filterToggle: '[data-catalog-filter-toggle]',
		close: '[data-catalog-filter-close-toggle]',
		addToCart: '.card_buy_button',
	},
	index: {
		citySelect: '[data-select="city"]',
		addressSelect: '[data-select="address"]',
	},
	contacts: {
		addressesMap: '[data-addresses-map="contacts"]',
	},
	spinner: '[data-spinner]',
	onlineRegistrationModal: {
		toggle: '.js-modal-bid',
		close: '.modal__header-close',
		navigation: {
			prev: '[data-rm-prev-step-btn]',
			next: '[data-rm-next-step-btn]',
		},
		stepper: {
			step: '[data-rm-stepper-step]',
			stepContent: '[data-rm-step]',
			activeStepContent: '.active[data-rm-step]',
		},
		services: {
			card: '[data-rm-service]',
			selectedCard: 'modal__item--chosen',
			list: '[data-rm-services-list]',
		},
		addresses: {
			selectedClassName: 'selected',
			map: '[data-addresses-map="modal"]',
			container: '[data-rm-addresses-list]',
		},
		datePicker: '[data-date-picker]',
		todayInfo: '[data-date-picker-today]',
		selectedDay: '[data-date-picker-selected]',
		timeContainer: '[data-rm-times]',
		selectedDatetimeInfo: '[data-rm-selected-datetime-info]',
		processingDataAgree: '[data-rm-personal-data-agree]',
		nameInput: '[data-rm-name-input]',
		phoneInput: '[data-rm-phone-input]',
		commentInput: '[data-rm-comment-input]',
		showClassName: 'modal--show',
		navBtnHiddenClassName: 'modal__btn--hidden',
		stepCurrentClassName: 'current',
		stepPassedClassName: 'passed',
		stepActiveClassName: 'active',
		dNoneClassName: 'd-none',
	},
	search: {
		input: '.search-input',
		resultsContainer: '.search-results',
		result: '.search-result',
	},
};
